/* eslint-disable @typescript-eslint/no-empty-function */
import { Injectable } from '@angular/core';

import { ReplaySubject } from 'rxjs';
import { EstadoSesion } from '../interfaces/arbitro-interfaces';

@Injectable({
  providedIn: 'root'
})
export class DataArbitroService {
  constructor(
  ) { }

  //cuando se ingresa se pide al Arbitro un ID de sesión q se debe utilizar por toda la sesión
  arbitroSesion: string = '';
  arbitroSesionUpdate(b: string) {
    this.arbitroSesion = b;
  }

  //Estado de la sesión actual
  arbitroEstadoSesion: EstadoSesion = new EstadoSesion;
  arbitroEstadoSesion_ = new ReplaySubject<EstadoSesion>(1);
  arbitroEstadoSesion$ = this.arbitroEstadoSesion_.asObservable();
  arbitroEstadoSesionUpdate(estses: EstadoSesion) {
    this.arbitroEstadoSesion = estses;
    this.arbitroEstadoSesion_.next(estses);
  }


  //para saber si ya estoy suscrito al
  arbitroEstadoSesionYaCargado: boolean = false;
  arbitroEstadoSesionYaCargadoUpdate(VF: boolean): void {
    this.arbitroEstadoSesionYaCargado = VF;
  }


  //para saber en todo el sistema si la sesión está en línea o fuera de línea
  sesionOnline: boolean = false;
  sesionOnline_ = new ReplaySubject<boolean>(1);
  sesionOnline$ = this.sesionOnline_.asObservable();
  sesionOnlineUpdate(so: boolean) {
    this.sesionOnline = so;
    this.sesionOnline_.next(so);
  }

  //cuando entro a una pantalla donde se puede editar un elemento (ej: art, pers, etc.)
  //debo pedir al árbitro un bloqueo indicando el elemento y su id.
  //la respuesta será un observable a un boolean, no un simple boolean, 
  //porque, en condiciones especiales, el árbitro podría quitar el bloqueo concedido
  arbitroBloqueoConcedido: string = '';   //puede ser '', Ok y Negado
  arbitroBloqueoConcedido_ = new ReplaySubject<string>(1);
  arbitroBloqueoConcedido$ = this.arbitroBloqueoConcedido_.asObservable();
  arbitroBloqueoConcedidoOk: boolean = false;   //es true si el bloqueo es Ok
  arbitroBloqueoConcedidoOk_ = new ReplaySubject<boolean>(1);  //solo activo si el bloqueo es Ok
  arbitroBloqueoConcedidoOk$ = this.arbitroBloqueoConcedidoOk_.asObservable();
  arbitroBloqueoConcedidoUpdate(b: string) {
    this.arbitroBloqueoConcedido = b;
    this.arbitroBloqueoConcedido_.next(b);
    if (b == 'Ok') {
      this.arbitroBloqueoConcedidoOk = true;
      this.arbitroBloqueoConcedidoOk_.next(true);
    }
  }

  //qué otro usuario tiene el bloqueo al registro actual
  arbitroBloqueoActual: string = '';
  arbitroBloqueoActual_ = new ReplaySubject<string>(1);
  arbitroBloqueoActual$ = this.arbitroBloqueoActual_.asObservable();
  arbitroBloqueoActualUpdate(b: string) {
    this.arbitroBloqueoActual = b;
    this.arbitroBloqueoActual_.next(b);
  }


}
